import { HTTP } from '../../utils'

export const getResults = (data) => {
  let url = '/elasticsearch/' + data.indexList + '/search?libraryIdList=' + data.libraryList
  if (data.useDefaultFields === false || data.useDefaultFields === 'false') {
    url += '&useDefaultFields=false'
  }
  return HTTP().post(url, data.payload)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const deleteContent = (uuids) => {
  return HTTP().delete('learningcontent/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
    return null
  })
}

export const deleteTopic = (uuids) => {
  return HTTP().delete('topic/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
    return null
  })
}

export const deleteStream = (uuids) => {
  return HTTP().delete('entity/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
    return null
  })
}

export const deleteCatalog = (uuids) => {
  return HTTP().delete('catalog/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
    return null
  })
}

export const deleteJob = (uuids) => {
  return HTTP().delete('job/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
    return null
  })
}

export const deleteClub = (uuids) => {
  return HTTP().delete('club/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
    return null
  })
}

export const deleteEvent = (uuids) => {
  return HTTP().delete('event/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
    return null
  })
}

export const getAllLibraryForUser = () => {
  const userId = localStorage.getItem('userid')
  return HTTP().get('learningspace/user?userUuid=' + userId)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getRecommendations = (userId, entityType) => {
  let url = 'recommendation/user/'+userId+'/entity/'+entityType
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getAllEntityIdsWithRecommendation = (entityType) => {
  let url = 'recommendation/all/entity/'+entityType
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const getRecommendationForEntity = (entityUuid) => {
  let url = 'recommendation/entity/'+entityUuid
  return HTTP().get(url)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}
export const addRecommendedToUsers = (entityId, uuids) => {
  return HTTP().put('recommendation/add/job/'+entityId+'?uuids='+uuids)
  .then(res => {
    return res
  })
  .catch(e => {
    console.log(e)
  })
}
 
export const getLibraryPositionMapping = () => {
  return HTTP().get('configuration/library_position_mapping')
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const updateUserPreferences = (uuid, data) => {
  return HTTP().put('user/' + uuid, data)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}

export const execCopyMoveContent = (uuids, targetLibraryId, action) => {
  const operation = (action === 'Copy') ? 'copyContent/' : 'moveContent/'
  const url = 'learningcontent/' + operation + uuids + '/' + targetLibraryId
  return HTTP().put(url)
  .then(res => {
    return res
  })
  .catch(e => {
    console.log(e)
  })
}
export const getDepartments = (libraryUuid, semesterCode) => {
  return HTTP().get('/deliverycontext/' + libraryUuid + '/departments?currentSemester=' + semesterCode)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getAIContents = (courseId) => { 
  return HTTP().get('/deliverycontext/' + courseId + '/aicontent')
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCompetencyLogic = (courseId, type) => { 
  return HTTP().get('/competencyLogic/course/' + courseId + '/type/'+type)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}
export const getDivisions = (libraryUuid, semesterCode) => {
  return HTTP().get('/deliverycontext/' + libraryUuid + '/divisions?currentSemester=' + semesterCode)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getSubjects = (libraryUuid, semesterCode) => {
  return HTTP().get('/deliverycontext/' + libraryUuid + '/subjects?currentSemester=' + semesterCode)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getInstructors = (libraryUuid, semesterCode) => {
  return HTTP().get('/deliverycontext/' + libraryUuid + '/instructors?currentSemester=' + semesterCode)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getDataForCourseSearch = (currentYear, currentSemester) => {
  let url = ''
  if (currentSemester && currentYear) {
    url = '/courseSearchDropDowns/?currentYear=' + currentYear + '&currentSemester=' + currentSemester
  } else if (currentSemester) {
    url = '/courseSearchDropDowns/?currentSemester=' + currentSemester
  } else {
    return
  }
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCourseSearches = (uuid) => {
  let url = ''
  if (uuid) {
    url = '/courseSearch/' + uuid
  } else {
    url = '/courseSearch/findByOwnerId/'
  }
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const getCourseFlags = (institutionId, semesterCode) => {
  let url = ''
  if (institutionId && semesterCode) {
    url = '/deliverycontext/' + institutionId + '/courseFlags?currentSemester=' + semesterCode
  } else {
    return
  }
  return HTTP().get(url)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const saveCourseSearch = (courseSearchObj, owningLibraryId) => {
  let url = ''
  if (courseSearchObj.uuid) {
    url = '/courseSearch/' + courseSearchObj.uuid + '?parentSpaceId=' + owningLibraryId
  } else {
    url = '/courseSearch?parentSpaceId=' + owningLibraryId
  }
  return HTTP().put(url, courseSearchObj)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const deleteCourseSearch = (courseSearchId, owningLibraryId) => {
  let url = ''
  if (courseSearchId && owningLibraryId) {
    url = '/courseSearch/' + courseSearchId + '?parentSpaceId=' + owningLibraryId
  } else {
    console.log('Error: courseSearchId and/or owningLibraryId are null.')
    return
  }
  return HTTP().delete(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const callSearchForBulkOperation = (data) => {
  let url = '/elasticsearch/' + data.indexList + '/search/bulkOperation?operation=' + data.operation
  if (data.targetLibraryId) {
    url += '&targetLibraryId=' + data.targetLibraryId
  }
  return HTTP().post(url, data.payload)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}



// WEBPACK FOOTER //
// ./src/app/search/api.js